import React from 'react';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@nextiva/next-ui';
import { QueryClient, QueryClientProvider } from 'react-query';
import {
  QueryClient as TanstackQueryClient,
  QueryClientProvider as TanstackQueryClientProvider,
} from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import {
  ThemeProvider as NextUiThemeProvider,
  defaultTheme,
} from '@nextiva/next-ui-components';
import { Auth } from 'components/Auth';
import { FeatureFlags } from 'components/FeatureFlags';
import { FeatureFlag } from 'components/AccessResolvers/featureFlag';
import Routes from '../routes';
import { createStore } from '../store';

const store = createStore({}, { debugApi: false }, { reduxLogger: false });

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      retry: false,
    },
  },
});
const tanstackQueryClient = new TanstackQueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      retry: false,
    },
  },
});

const Root = () => {
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <TanstackQueryClientProvider client={tanstackQueryClient}>
          <NextUiThemeProvider theme={defaultTheme}>
            <ThemeProvider theme="modern">
              <Auth>
                <FeatureFlags>
                  <FeatureFlag>
                    <Routes />
                  </FeatureFlag>
                </FeatureFlags>
              </Auth>
            </ThemeProvider>
          </NextUiThemeProvider>
          <ReactQueryDevtools initialIsOpen={false} />
        </TanstackQueryClientProvider>
      </QueryClientProvider>
    </Provider>
  );
};

export default Root;
